import { render, staticRenderFns } from "./LicencesList.vue?vue&type=template&id=476378fd"
import script from "./LicencesList.vue?vue&type=script&lang=js"
export * from "./LicencesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports